import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getUserSocialProfile = async (params) => {
  const res = await axios.middleware(
    "https://middleware.cadernovirtual.com.br/Social.asmx/PainelPerfil",
    {
      params,
    }
  );

  return res[0].data[0];
};

export const useGetUserSocialProfile = ({
  config,
  studentId = _cookies.getItem("auth").user.alunoid,
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["socialMediaUser", { studentId }],
    queryFn: () =>
      getUserSocialProfile({
        alunoid: studentId,
      }),
  });
};
